module.exports = __webpack_public_path__ + "img/btn_cancel3.5e31a374.png";